import { openDB } from 'idb';

export default class AdiaLive5DBAccessor{
	static checkDBExists(dbName){
		return new Promise(function (resolve, reject) {
			let dbExists = true;
			const request = window.indexedDB.open(dbName);
			request.onupgradeneeded = function (e){
				e.target.transaction.abort();
				dbExists = false;

				resolve(dbExists)
			}
			request.onerror = function(e){
				if(e.target.error.code != 20){
					reject('Error checking DB:', e.target.error.code);
				}
			}
			request.onsuccess = function(event) {
				resolve(dbExists)
			};
		})
	}

	static createObjectStores(dbName, objectStoreDefinitions){
		return openDB(dbName, 1, {
			upgrade(upgradeDB){
				for(let i = 0; i < objectStoreDefinitions.length; i++){
					const objectStoreDefinition = objectStoreDefinitions[i];

					if(!upgradeDB.objectStoreNames.contains(objectStoreDefinition.name)){
						const newObjectStore = upgradeDB.createObjectStore(objectStoreDefinition.name, {keyPath: objectStoreDefinition.keyPath, autoIncrement: objectStoreDefinition.autoIncrement});

						for(let j = 0; j < objectStoreDefinition.indexes.length; j++){
							const indexDefinition = objectStoreDefinition.indexes[j];
							newObjectStore.createIndex(indexDefinition.name, indexDefinition.name, {unique: indexDefinition.unique});
						}
					}
				}

				return upgradeDB.objectStoreNames;	// Returned in promise.then
			}
		})
	}

	constructor(){
		this.dbReady = null;
		this.dbName = null;
		this.objectStoreName = null;
	}

	init(dbName, objectStoreName){
		this.dbName = dbName;
		this.objectStoreName = objectStoreName;

		this.dbReady = openDB(dbName, 1);

		return this.dbReady
			.then(function(db){
				return {dbName: db.name, dbVersion: db.version};
			});
	}

	add(item){
		const _this = this;

		return this.dbReady
		.then(function(db){
			const tx = db.transaction(_this.objectStoreName, 'readwrite');
			const store = tx.objectStore(_this.objectStoreName);
			const addRequest = store.add(item);

			addRequest.onerror = function(){
				console.error('Error adding item:', addRequest.error);
			}

			return tx.complete;
		})
		.catch(function(ex){
			console.error('Error adding item in ' + _this.objectStoreName + ':', ex);
		});
	};

	put(item){
		const _this = this;

		return this.dbReady
		.then(function(db){
			const tx = db.transaction(_this.objectStoreName, 'readwrite');
			const store = tx.objectStore(_this.objectStoreName);
			store.put(item);

			return tx.complete;
		})
		.catch(function(ex){
			console.error('Error updating item:', ex);
		});
	};

	get(key, indexName, keyOnly){
		const _this = this;

		return this.dbReady
		.then(function(db){
			const tx = db.transaction(_this.objectStoreName, 'readonly');
			const store = tx.objectStore(_this.objectStoreName);

			const target = (typeof indexName == 'string') ? store.index(indexName) : store;

			if(keyOnly){
				return target.getKey(key);
			}
			else{
				return target.get(key);
			}
		})
		.catch(function(error){
			console.error('Error getting item:', error);
		})
	};

	getAll(constraints){
		const _this = this;

		return this.dbReady
		.then(function(db){
			const tx = db.transaction(_this.objectStoreName, 'readwrite');
			const store = tx.objectStore(_this.objectStoreName);

			if(constraints && typeof constraints === 'object' && Object.keys(constraints).length !== 0){
				let query = null;
				if(constraints.hasOwnProperty('key')){
					query = IDBKeyRange.only(constraints.key)
				}
				else if(constraints.hasOwnProperty('biggerThan') && constraints.hasOwnProperty('smallerThan')){
					query = IDBKeyRange.bound(constraints.biggerThan, constraints.smallerThan, true, true);
				}
				else if(constraints.hasOwnProperty('biggerThan')){
					query = IDBKeyRange.lowerBound(constraints.biggerThan, true);
				}
				else if(constraints.hasOwnProperty('smallerThan')){
					query = IDBKeyRange.upperBound(constraints.smallerThan, true);
				}

				const target = (constraints.hasOwnProperty('indexName') && typeof constraints.indexName == 'string') ? store.index(constraints.indexName) : store;

				if(constraints.hasOwnProperty('keysOnly') && constraints.keysOnly){
					if(query){
						return target.getAllKeys(query);
					}
					else{
						return target.getAllKeys();
					}
				}
				else{
					if(query){
						return target.getAll(query);
					}
					else{
						return target.getAll();
					}
				}
			}
			else{
				return store.getAll();
			}
		})
		.catch(function(ex){
			console.error('Error getting all:');
			console.error(ex);
		});
	};

	delete(key, indexName){
		const _this = this;

		return this.dbReady
		.then(function(db){
			const tx = db.transaction(_this.objectStoreName, 'readwrite');
			const store = tx.objectStore(_this.objectStoreName);

			if(typeof indexName != 'string'){
				store.delete(key);
			}
			else{
				const storeIndex = store.index(indexName);

				storeIndex.openKeyCursor(IDBKeyRange.only(key))
					.then(function deleteItem(cursor) {
						if (!cursor) {
							return;
						}

						store.delete(cursor.primaryKey);

						return cursor.continue().then(deleteItem);
					})
			}

			return tx.complete;
		})
		.catch(function(error){
			console.error('Error getting item:', ex);
		});
	};

	count(constraints){
		const _this = this;

		return this.dbReady
		.then(function(db){
			const tx = db.transaction(_this.objectStoreName, 'readonly');
			const store = tx.objectStore(_this.objectStoreName);

			if(constraints && typeof constraints === 'object' && Object.keys(constraints).length !== 0){
				let query = null;
				if(constraints.hasOwnProperty('key')){
					query = IDBKeyRange.only(constraints.key)
				}
				else if(constraints.hasOwnProperty('biggerThan') && constraints.hasOwnProperty('smallerThan')){
					query = IDBKeyRange.bound(constraints.biggerThan, constraints.smallerThan);
				}
				else if(constraints.hasOwnProperty('biggerThan')){
					query = IDBKeyRange.lowerBound(constraints.biggerThan);
				}
				else if(constraints.hasOwnProperty('smallerThan')){
					query = IDBKeyRange.upperBound(constraints.smallerThan);
				}

				const target = (constraints.hasOwnProperty('indexName') && typeof constraints.indexName == 'string') ? store.index(constraints.indexName) : store;

				if(query){
					return target.count(query);
				}
				else{
					return target.count();
				}
			}
			else{
				return store.count();
			}
		})
		.then(function(count){
			return count;
		})
		.catch(function(ex){
			console.error('Error getting count:', ex);
		})
	}
}